import {
  currentEnvironmentNotBuildEnvironment,
  getEnvironment,
  isLocalhost,
  isPrDeployment,
} from '@backoffice-frontend/environment'
import {
  Box,
  backroundEnv,
  SwitchEnvironmentDropdown,
} from '@backoffice-frontend/patterns'
import { Callout, Card, Heading, Text } from '@moia-dev/pace-web'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationSelector } from '../LoginView/OrganizationSelector'

export const PublicAppViewContentLayout = ({
  children,
  title,
  isMobile,
  onOrganizationChange,
  description,
}: {
  children: React.ReactNode
  title: string
  isMobile: boolean
  onOrganizationChange?: () => void
  description?: string
}) => {
  const { t } = useTranslation()

  const isBrowserSupported = React.useMemo(() => {
    const { userAgent } = navigator
    return userAgent.includes('Edg/') || userAgent.includes('Chrome/')
  }, [])

  const showEnvironmentBanner =
    currentEnvironmentNotBuildEnvironment() || isLocalhost
  const showEnvironmentSwitcher =
    currentEnvironmentNotBuildEnvironment() || isLocalhost
  const showOrganizationSelector = isLocalhost || isPrDeployment

  return (
    <Card
      css={theme => ({
        padding: 0,
        width: isMobile ? '300px' : '400px',
        background: theme.semantic.ColorSurfaceDefault,
        color: theme.semantic.ColorContentDefault,
        overflow: 'hidden',
        boxShadow: 'none',
      })}
    >
      {showEnvironmentBanner && (
        <span
          css={theme => ({
            background: `linear-gradient(90deg, ${backroundEnv[getEnvironment()].dark} 0%, ${backroundEnv[getEnvironment()].bright} 100%)`,
            padding: `${theme.space.Space1} 0`,
            color:
              theme.semantic
                .ColorContentOnContrastCriticalSuccessDefaultAlternative,
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center',
            letterSpacing: '0.75px',
          })}
        >
          {getEnvironment().toUpperCase()}
        </span>
      )}
      <div
        css={theme => ({
          padding: isMobile ? theme.space.Space2 : theme.space.Space6,
        })}
      >
        <Heading css={{ textAlign: 'center' }} size={isMobile ? 'md' : 'xl'}>
          {title}
        </Heading>
        {description && (
          <div
            css={theme => ({
              margin: isMobile
                ? `${theme.space.Space3} 0`
                : `${theme.space.Space6} 0`,
              textAlign: 'center',
            })}
          >
            <Text>{description}</Text>
          </div>
        )}
        {!isBrowserSupported && (
          <Callout
            variant={
              currentEnvironmentNotBuildEnvironment() ? 'critical' : 'warning'
            }
            title={t('loginView_browserNotSupported_header')}
          >
            {t('loginView_browserNotSupported_caption')}
          </Callout>
        )}
        {children}
        {showOrganizationSelector && onOrganizationChange && (
          <Box paddingTop={2}>
            <Text size="lg">{t('loginView_organizationSelector')}</Text>
            <OrganizationSelector onOrganizationChange={onOrganizationChange} />
          </Box>
        )}
        {showEnvironmentSwitcher && (
          <Box paddingTop={2}>
            <Text size="lg">{t('loginView_environmentSelector')}</Text>
            <SwitchEnvironmentDropdown />
          </Box>
        )}
      </div>
    </Card>
  )
}
